import { axiosClient } from '../axios';

const completeDocument = async (signatureId) => axiosClient.put('/document/complete', { signatureId });

export const createDocumentService = async (signatureId) => axiosClient.post('/document/createservice', { signatureId });

export default completeDocument;
